export default __webpack_public_path__ + "static/media/Freebooter's Belt of Pierced Flesh.7e8cea06.jpg";